var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system",attrs:{"id":"sys"}},[_c('Header'),_c('main',{staticClass:"main page",attrs:{"id":"main"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }